var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.266 11.7857L11.2993 10.7857L8.73268 8.20234V5.01901H7.36602V8.76901L10.266 11.7857ZM7.99935 15.5857C7.02157 15.5857 6.10213 15.3996 5.24102 15.0273C4.3799 14.6551 3.6299 14.1496 2.99102 13.5107C2.35213 12.8718 1.84657 12.1218 1.47435 11.2607C1.10213 10.3996 0.916016 9.48012 0.916016 8.50234C0.916016 7.52457 1.10213 6.60512 1.47435 5.74401C1.84657 4.8829 2.35213 4.1329 2.99102 3.49401C3.6299 2.85512 4.3799 2.34679 5.24102 1.96901C6.10213 1.59123 7.02157 1.40234 7.99935 1.40234C8.97713 1.40234 9.89657 1.59123 10.7577 1.96901C11.6188 2.34679 12.3688 2.85512 13.0077 3.49401C13.6466 4.1329 14.1549 4.8829 14.5327 5.74401C14.9105 6.60512 15.0993 7.52457 15.0993 8.50234C15.0993 9.48012 14.9105 10.3996 14.5327 11.2607C14.1549 12.1218 13.6466 12.8718 13.0077 13.5107C12.3688 14.1496 11.6188 14.6551 10.7577 15.0273C9.89657 15.3996 8.97713 15.5857 7.99935 15.5857ZM7.98268 14.019C9.5049 14.019 10.8077 13.4829 11.891 12.4107C12.9743 11.3385 13.516 10.0357 13.516 8.50234C13.516 6.98012 12.9743 5.68012 11.891 4.60234C10.8077 3.52457 9.51046 2.98568 7.99935 2.98568C6.47713 2.98568 5.17713 3.52457 4.09935 4.60234C3.02157 5.68012 2.48268 6.98012 2.48268 8.50234C2.48268 10.0357 3.02157 11.3385 4.09935 12.4107C5.17713 13.4829 6.47157 14.019 7.98268 14.019V14.019Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlTimeIcon);
export default __webpack_public_path__ + "static/media/bl-time-icon.68715e8e478f0cc9cd89bb15a2533859.svg";
export { ForwardRef as ReactComponent };